import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { PedidoClicheriaStatus } from '../../domain';

@Component({
    selector: 'sgt-pedido-clicheria-status-multiselect',
    templateUrl: './pedido-clicheria-status-multiselect.component.html',
    styleUrls: ['./pedido-clicheria-status-multiselect.component.less'],
})
export class PedidoClicheriaStatusMultiselectComponent implements OnInit {
    /** Status da clicheria selecionados */
    @Input() idsStatusClicheria: number[];
    /** Ao alterar a seleção dos status clicheria */
    @Output() idsStatusClicheriaChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Status';
    @Input() checked = 'Status da Clicheria';
    @Input() checkedPlural = 'Status da Clicheria';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum status da clicheria encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[] = [];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pedido-clicheria-status ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os statuses da clicheria para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        PedidoClicheriaStatus.getAll().forEach(status => {
            selects.push({
                id: status.id,
                name: status.nome
            });
        });

        this.options = selects;
    }

    /** Ao alterar a seleção dos statuses da clicheria */
    onSelectionChange() {
        this.idsStatusClicheriaChange.emit(this.idsStatusClicheria);
    }
}
